import { render, staticRenderFns } from "./dailyWritingPage.vue?vue&type=template&id=368c113a&scoped=true&"
import script from "./dailyWritingPage.vue?vue&type=script&lang=js&"
export * from "./dailyWritingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c113a",
  null
  
)

export default component.exports